<div class="container">
    <div class="row">
        <div class="col-12">
            <h2 class="card-title section-title">India's <em>only</em> trusted partner<br><em>for</em> GENERATIONS<span class="wow"></span></h2>
        </div>
        <!-- <div *ngIf="socialReviews.length" class="col-12" style="height:650px;overflow-y:auto;"> -->
        <div class="col-12" style="height:650px;overflow-y:auto;">
            <div class="row">
                    <ng-container *ngFor="let card of shownReviews">
                            <div class="col-lg-4 col-md-6">
                                    <div class="testimonials-card">
                                    <div class="testimonials-header">
                                            <a href="#" class="testimonials-logo"><img [src]="card.field_social_icon" alt=""></a>
                                            <div class="rating">
                                            {{card.social_rating}}
                                            <span class="star" >
                                                    <span *ngIf="card.social_rating=='0'">
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='0.5'">
                                                            <i class="fas fa-star-half-alt"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='1'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='1.5'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star-half-alt"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='2'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='2.5'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star-half-alt"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='3'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='3.5'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star-half-alt"></i>
                                                            <i class="far fa-star"></i>
                                                    </span>
                                                    <span *ngIf="card.social_rating=='4'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>  
                                                            <i class="far fa-star"></i>                                   
                                                    </span>
                                                    <span *ngIf="card.social_rating=='4.5'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>  
                                                            <i class="fas fa-star-half-alt"></i>                                  
                                                    </span>
                                                    <span *ngIf="card.social_rating=='5'">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>  
                                                            <i class="fas fa-star"></i>                                   
                                                    </span>
                                            </span>
                                            
                                            </div>
                                    </div>
                                    <div class="testimonials-profile">
                                            <img [src]="card.field_customer_image" alt="" class="testimonials-user">
                                            <span class="testimonials-name">{{card.customer_name}}, {{card.customer_location}}</span>
                                    </div>
                                    <div class="testimonaials-description">
                                            <p>{{card.description_social_test}}</p>
                                    </div>
                                    </div>
                            </div>
                    </ng-container>
            </div>
        </div>
        <!-- <div *ngIf="socialReviews.length" class="col-12 text-center" > -->
        <!-- <div *ngIf="socialReviews" class="col-12 text-center" >
            <a *ngIf="showMoreItems" class="btn read-more" (click)="showMore()">Show more Testimonials &nbsp; <i class="fas fa-chevron-down"></i></a>
            <a *ngIf="hideMoreItems" class="btn read-more" (click)="hideMore()">Hide more Testimonials &nbsp; <i class="fas fa-chevron-up"></i></a>
        </div> -->
    </div>
</div>
